<div fxLayout="column" class="discount" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="100" class="container">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutAlign="start center" fxLayoutGap="32px">
      <mat-icon class="icon" svgIcon="ss3-percent" />
      <div fxLayout="column">
        <h2>
          Charity-Sponsored Pickups
          <span>Now Available!</span>
        </h2>
        <p>
          You might qualify for a charity-sponsored pickup, which could help reduce your donation cost. Some of our charity partners offer
          special support to cover part of the pickup fee, making it even easier for you to give back.
        </p>
        <p>
          When you schedule your pickup, you’ll automatically be considered for one of these sponsored services. Take the next step today
          and see how your donation can make an even bigger impact!
        </p>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center">
      <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
        <span fxFlex="100">Check if you’re eligible</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
